import React, { useState } from "react";
import "./AntonymMatch.css";

const questionsData = [
  { word: "HAPPY", options: ["SAD", "JOYFUL", "GLAD"], answer: "SAD", reason: "‘Sad’ is the opposite of ‘Happy’." },
  { word: "HOT", options: ["COLD", "WARM", "HEAT"], answer: "COLD", reason: "‘Cold’ is the opposite of ‘Hot’." },
  { word: "BIG", options: ["SMALL", "LARGE", "HUGE"], answer: "SMALL", reason: "‘Small’ is the opposite of ‘Big’." },
  { word: "FAST", options: ["SLOW", "QUICK", "SPEED"], answer: "SLOW", reason: "‘Slow’ is the opposite of ‘Fast’." },
  { word: "LIGHT", options: ["DARK", "BRIGHT", "SHINY"], answer: "DARK", reason: "‘Dark’ is the opposite of ‘Light’." },
  { word: "STRONG", options: ["WEAK", "POWERFUL", "MIGHTY"], answer: "WEAK", reason: "‘Weak’ is the opposite of ‘Strong’." },
  { word: "UP", options: ["DOWN", "HIGH", "TOP"], answer: "DOWN", reason: "‘Down’ is the opposite of ‘Up’." },
  { word: "IN", options: ["OUT", "INSIDE", "WITHIN"], answer: "OUT", reason: "‘Out’ is the opposite of ‘In’." },
  { word: "DAY", options: ["NIGHT", "SUN", "MORNING"], answer: "NIGHT", reason: "‘Night’ is the opposite of ‘Day’." },
  { word: "OPEN", options: ["CLOSE", "SHUT", "LOCK"], answer: "CLOSE", reason: "‘Close’ is the opposite of ‘Open’." },
  { word: "HIGH", options: ["LOW", "TALL", "UP"], answer: "LOW", reason: "‘Low’ is the opposite of ‘High’." },
  { word: "EARLY", options: ["LATE", "SOON", "FAST"], answer: "LATE", reason: "‘Late’ is the opposite of ‘Early’." },
  { word: "YOUNG", options: ["OLD", "NEW", "FRESH"], answer: "OLD", reason: "‘Old’ is the opposite of ‘Young’." },
  { word: "GOOD", options: ["BAD", "FINE", "NICE"], answer: "BAD", reason: "‘Bad’ is the opposite of ‘Good’." },
  { word: "EMPTY", options: ["FULL", "VACANT", "HOLLOW"], answer: "FULL", reason: "‘Full’ is the opposite of ‘Empty’." },
  { word: "RICH", options: ["POOR", "WEALTHY", "MONEY"], answer: "POOR", reason: "‘Poor’ is the opposite of ‘Rich’." },
  { word: "LOVE", options: ["HATE", "LIKE", "CARE"], answer: "HATE", reason: "‘Hate’ is the opposite of ‘Love’." },
  { word: "KIND", options: ["CRUEL", "GENTLE", "SOFT"], answer: "CRUEL", reason: "‘Cruel’ is the opposite of ‘Kind’." },
  { word: "NARROW", options: ["WIDE", "THIN", "SLIM"], answer: "WIDE", reason: "‘Wide’ is the opposite of ‘Narrow’." },
  { word: "HARD", options: ["SOFT", "SOLID", "TOUGH"], answer: "SOFT", reason: "‘Soft’ is the opposite of ‘Hard’." },
  { word: "NOISY", options: ["QUIET", "LOUD", "SOUND"], answer: "QUIET", reason: "‘Quiet’ is the opposite of ‘Noisy’." },
  { word: "STRONG", options: ["WEAK", "POWERFUL", "MIGHTY"], answer: "WEAK", reason: "‘Weak’ is the opposite of ‘Strong’." },
  { word: "WIN", options: ["LOSE", "GAIN", "VICTORY"], answer: "LOSE", reason: "‘Lose’ is the opposite of ‘Win’." },
  { word: "BUY", options: ["SELL", "PURCHASE", "SHOP"], answer: "SELL", reason: "‘Sell’ is the opposite of ‘Buy’." },
  { word: "ARRIVE", options: ["DEPART", "COME", "ENTER"], answer: "DEPART", reason: "‘Depart’ is the opposite of ‘Arrive’." },
  { word: "LAUGH", options: ["CRY", "SMILE", "GIGGLE"], answer: "CRY", reason: "‘Cry’ is the opposite of ‘Laugh’." },
  { word: "REMEMBER", options: ["FORGET", "RECALL", "KNOW"], answer: "FORGET", reason: "‘Forget’ is the opposite of ‘Remember’." },
  { word: "START", options: ["STOP", "BEGIN", "GO"], answer: "STOP", reason: "‘Stop’ is the opposite of ‘Start’." },
  { word: "NORTH", options: ["SOUTH", "EAST", "WEST"], answer: "SOUTH", reason: "‘South’ is the opposite of ‘North’." },
  { word: "EAST", options: ["WEST", "NORTH", "SOUTH"], answer: "WEST", reason: "‘West’ is the opposite of ‘East’." },
  { word: "BEFORE", options: ["AFTER", "PRIOR", "EARLY"], answer: "AFTER", reason: "‘After’ is the opposite of ‘Before’." },
  { word: "TRUE", options: ["FALSE", "REAL", "FACT"], answer: "FALSE", reason: "‘False’ is the opposite of ‘True’." },
  { word: "SUCCESS", options: ["FAILURE", "WIN", "GAIN"], answer: "FAILURE", reason: "‘Failure’ is the opposite of ‘Success’." },
  { word: "SAFE", options: ["DANGEROUS", "SECURE", "PROTECTED"], answer: "DANGEROUS", reason: "‘Dangerous’ is the opposite of ‘Safe’." },
  { word: "ASLEEP", options: ["AWAKE", "REST", "NAP"], answer: "AWAKE", reason: "‘Awake’ is the opposite of ‘Asleep’." },
  { word: "FRIEND", options: ["ENEMY", "PAL", "ALLY"], answer: "ENEMY", reason: "‘Enemy’ is the opposite of ‘Friend’." },
  { word: "INSIDE", options: ["OUTSIDE", "WITHIN", "INNER"], answer: "OUTSIDE", reason: "‘Outside’ is the opposite of ‘Inside’." },
  { word: "WINTER", options: ["SUMMER", "SPRING", "AUTUMN"], answer: "SUMMER", reason: "‘Summer’ is the opposite of ‘Winter’." },
  { word: "HARDWORKING", options: ["LAZY", "BUSY", "ACTIVE"], answer: "LAZY", reason: "‘Lazy’ is the opposite of ‘Hardworking’." },
  { word: "STRONG", options: ["WEAK", "POWERFUL", "MIGHTY"], answer: "WEAK", reason: "‘Weak’ is the opposite of ‘Strong’." },
  { word: "POLITE", options: ["RUDE", "KIND", "GENTLE"], answer: "RUDE", reason: "‘Rude’ is the opposite of ‘Polite’." },
  { word: "HUMBLE", options: ["PROUD", "MODEST", "QUIET"], answer: "PROUD", reason: "‘Proud’ is the opposite of ‘Humble’." },
  { word: "TALL", options: ["SHORT", "HIGH", "BIG"], answer: "SHORT", reason: "‘Short’ is the opposite of ‘Tall’." },
  { word: "DEEP", options: ["SHALLOW", "LOW", "BOTTOM"], answer: "SHALLOW", reason: "‘Shallow’ is the opposite of ‘Deep’." },
  { word: "STRONG", options: ["WEAK", "POWERFUL", "MIGHTY"], answer: "WEAK", reason: "‘Weak’ is the opposite of ‘Strong’." },
  { word: "HARD", options: ["SOFT", "SOLID", "TOUGH"], answer: "SOFT", reason: "‘Soft’ is the opposite of ‘Hard’." },
  

  { word: "ALIVE", options: ["DEAD", "LIVING", "ACTIVE"], answer: "DEAD", reason: "‘Dead’ is the opposite of ‘Alive’." },
  { word: "ASCEND", options: ["DESCEND", "CLIMB", "RISE"], answer: "DESCEND", reason: "‘Descend’ is the opposite of ‘Ascend’." },
  { word: "ATTACK", options: ["DEFEND", "FIGHT", "STRIKE"], answer: "DEFEND", reason: "‘Defend’ is the opposite of ‘Attack’." },
  { word: "BEAUTIFUL", options: ["UGLY", "PRETTY", "LOVELY"], answer: "UGLY", reason: "‘Ugly’ is the opposite of ‘Beautiful’." },
  { word: "BEGIN", options: ["END", "START", "OPEN"], answer: "END", reason: "‘End’ is the opposite of ‘Begin’." },
  { word: "BRAVE", options: ["COWARDLY", "FEARLESS", "BOLD"], answer: "COWARDLY", reason: "‘Cowardly’ is the opposite of ‘Brave’." },
  { word: "CLEAN", options: ["DIRTY", "PURE", "CLEAR"], answer: "DIRTY", reason: "‘Dirty’ is the opposite of ‘Clean’." },
  { word: "CLOSE", options: ["OPEN", "SHUT", "LOCK"], answer: "OPEN", reason: "‘Open’ is the opposite of ‘Close’." },
  { word: "CREATE", options: ["DESTROY", "MAKE", "BUILD"], answer: "DESTROY", reason: "‘Destroy’ is the opposite of ‘Create’." },
  { word: "CRY", options: ["LAUGH", "WEEP", "TEAR"], answer: "LAUGH", reason: "‘Laugh’ is the opposite of ‘Cry’." },
  { word: "DEFEAT", options: ["VICTORY", "LOSS", "FAIL"], answer: "VICTORY", reason: "‘Victory’ is the opposite of ‘Defeat’." },
  { word: "DRY", options: ["WET", "ARID", "THIRSTY"], answer: "WET", reason: "‘Wet’ is the opposite of ‘Dry’." },
  { word: "ENTER", options: ["EXIT", "COME", "JOIN"], answer: "EXIT", reason: "‘Exit’ is the opposite of ‘Enter’." },
  { word: "EXCLUDE", options: ["INCLUDE", "REMOVE", "OMIT"], answer: "INCLUDE", reason: "‘Include’ is the opposite of ‘Exclude’." },
  { word: "FAIL", options: ["SUCCEED", "LOSE", "FALL"], answer: "SUCCEED", reason: "‘Succeed’ is the opposite of ‘Fail’." },
  { word: "FALSE", options: ["TRUE", "FAKE", "WRONG"], answer: "TRUE", reason: "‘True’ is the opposite of ‘False’." },
  { word: "FEMALE", options: ["MALE", "WOMAN", "GIRL"], answer: "MALE", reason: "‘Male’ is the opposite of ‘Female’." },
  { word: "GAIN", options: ["LOSE", "WIN", "EARN"], answer: "LOSE", reason: "‘Lose’ is the opposite of ‘Gain’." },
  { word: "GUILTY", options: ["INNOCENT", "FAULTY", "BLAME"], answer: "INNOCENT", reason: "‘Innocent’ is the opposite of ‘Guilty’." },
  { word: "HAPPY", options: ["SAD", "GLAD", "JOYFUL"], answer: "SAD", reason: "‘Sad’ is the opposite of ‘Happy’." },
  { word: "HIDE", options: ["SHOW", "COVER", "CONCEAL"], answer: "SHOW", reason: "‘Show’ is the opposite of ‘Hide’." },
  { word: "IMPORT", options: ["EXPORT", "BRING", "LOAD"], answer: "EXPORT", reason: "‘Export’ is the opposite of ‘Import’." },
  { word: "INCREASE", options: ["DECREASE", "RISE", "GROW"], answer: "DECREASE", reason: "‘Decrease’ is the opposite of ‘Increase’." },
  { word: "JOIN", options: ["SEPARATE", "CONNECT", "LINK"], answer: "SEPARATE", reason: "‘Separate’ is the opposite of ‘Join’." },
  { word: "LAZY", options: ["ACTIVE", "IDLE", "REST"], answer: "ACTIVE", reason: "‘Active’ is the opposite of ‘Lazy’." },
  { word: "LEAD", options: ["FOLLOW", "GUIDE", "DIRECT"], answer: "FOLLOW", reason: "‘Follow’ is the opposite of ‘Lead’." },
  { word: "LEFT", options: ["RIGHT", "SIDE", "TURN"], answer: "RIGHT", reason: "‘Right’ is the opposite of ‘Left’." },
  { word: "LESS", options: ["MORE", "FEWER", "SMALL"], answer: "MORE", reason: "‘More’ is the opposite of ‘Less’." },
  { word: "LIVE", options: ["DIE", "SURVIVE", "EXIST"], answer: "DIE", reason: "‘Die’ is the opposite of ‘Live’." },
  { word: "MAJOR", options: ["MINOR", "BIG", "MAIN"], answer: "MINOR", reason: "‘Minor’ is the opposite of ‘Major’." },
  { word: "MANY", options: ["FEW", "LOTS", "SEVERAL"], answer: "FEW", reason: "‘Few’ is the opposite of ‘Many’." },
  { word: "MODERN", options: ["ANCIENT", "NEW", "LATEST"], answer: "ANCIENT", reason: "‘Ancient’ is the opposite of ‘Modern’." },
  { word: "NIGHT", options: ["DAY", "DARK", "EVENING"], answer: "DAY", reason: "‘Day’ is the opposite of ‘Night’." },
  { word: "NORTH", options: ["SOUTH", "EAST", "WEST"], answer: "SOUTH", reason: "‘South’ is the opposite of ‘North’." },
  { word: "PASS", options: ["FAIL", "GO", "MOVE"], answer: "FAIL", reason: "‘Fail’ is the opposite of ‘Pass’." },
  { word: "PEACE", options: ["WAR", "CALM", "QUIET"], answer: "WAR", reason: "‘War’ is the opposite of ‘Peace’." },
  { word: "PLURAL", options: ["SINGULAR", "MANY", "WORDS"], answer: "SINGULAR", reason: "‘Singular’ is the opposite of ‘Plural’." },
  { word: "PUSH", options: ["PULL", "MOVE", "PRESS"], answer: "PULL", reason: "‘Pull’ is the opposite of ‘Push’." },
  { word: "QUESTION", options: ["ANSWER", "ASK", "QUERY"], answer: "ANSWER", reason: "‘Answer’ is the opposite of ‘Question’." },
  { word: "QUIET", options: ["LOUD", "SILENT", "CALM"], answer: "LOUD", reason: "‘Loud’ is the opposite of ‘Quiet’." },
  { word: "RAPID", options: ["SLOW", "FAST", "QUICK"], answer: "SLOW", reason: "‘Slow’ is the opposite of ‘Rapid’." },
  { word: "REMEMBER", options: ["FORGET", "KNOW", "RECALL"], answer: "FORGET", reason: "‘Forget’ is the opposite of ‘Remember’." },
  { word: "RIGHT", options: ["WRONG", "LEFT", "TRUE"], answer: "WRONG", reason: "‘Wrong’ is the opposite of ‘Right’." },
  { word: "RISE", options: ["FALL", "UP", "GROW"], answer: "FALL", reason: "‘Fall’ is the opposite of ‘Rise’." },
  { word: "SAFE", options: ["DANGEROUS", "SECURE", "PROTECTED"], answer: "DANGEROUS", reason: "‘Dangerous’ is the opposite of ‘Safe’." },
  { word: "SHARP", options: ["DULL", "POINTED", "KEEN"], answer: "DULL", reason: "‘Dull’ is the opposite of ‘Sharp’." },
  { word: "SIMPLE", options: ["COMPLEX", "EASY", "PLAIN"], answer: "COMPLEX", reason: "‘Complex’ is the opposite of ‘Simple’." },
  
  { word: "NEAR", options: ["FAR", "CLOSE", "NEXT"], answer: "FAR", reason: "‘Far’ is the opposite of ‘Near’." },
  
];

// Fisher–Yates shuffle
const shuffleArray = (array) => {
  const arr = [...array];
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr;
};

export default function AntonymMatch() {
  // shuffle once when component mounts
  const [questions] = useState(() => shuffleArray(questionsData));
  const [currentIndex, setCurrentIndex] = useState(0);
  const [dropped, setDropped] = useState("");
  const [selected, setSelected] = useState("");
  const [message, setMessage] = useState("");
  const [reason, setReason] = useState("");
  const [score, setScore] = useState(0);
  const [mode, setMode] = useState("drag");

  const correctSound = new Audio("/sounds/correct.mp3");
  const wrongSound = new Audio("/sounds/wrong.wav");
  const winSound = new Audio("/sounds/win.mp3");

  const speak = (text) => {
    const utterance = new SpeechSynthesisUtterance(text);
    speechSynthesis.speak(utterance);
  };

  const checkAnswer = (choice) => {
    if (choice === questions[currentIndex].answer) {
      setMessage("🎉 Correct!");
      setReason(questions[currentIndex].reason);
      setScore(score + 10);
      correctSound.play();
      speak("Correct! " + questions[currentIndex].reason);
    } else {
      setMessage("❌ Wrong!");
      setReason(questions[currentIndex].reason);
      setScore(score - 5);
      wrongSound.play();
      speak("Wrong! " + questions[currentIndex].reason);
    }

    if (currentIndex + 1 < questions.length) {
      setTimeout(() => {
        setCurrentIndex(currentIndex + 1);
        setDropped("");
        setSelected("");
        setMessage("");
        setReason("");
      }, 3000);
    } else {
      setTimeout(() => {
        setMessage("🏆 You finished all questions!");
        winSound.play();
        speak("You finished all questions!");
      }, 2000);
    }
  };

  const handleDrop = (e) => {
    const antonym = e.dataTransfer.getData("text");
    setDropped(antonym);
    checkAnswer(antonym);
  };

  const handleQuizSubmit = () => {
    if (!selected) return;
    checkAnswer(selected);
  };

  return (
    <div className="match-container">
      <h1>🔗 Antonym Match</h1>
      <div className="mode-toggle">
        <button onClick={() => setMode("drag")} className={mode === "drag" ? "active" : ""}>Drag & Drop</button>
        <button onClick={() => setMode("quiz")} className={mode === "quiz" ? "active" : ""}>Quiz Mode</button>
      </div>

      <p className="clue">Word: {questions[currentIndex].word}</p>
      <p className="status">{message}</p>
      <p className="reason">{reason}</p>
      <p className="score">⭐ Score: {score}</p>
      <br/><br/>

      {mode === "drag" ? (
        <>
          <div className="options">
            {questions[currentIndex].options.map((opt, i) => (
              <div
                key={i}
                className="option-card"
                draggable
                onDragStart={(e) => e.dataTransfer.setData("text", opt)}
                onClick={() => checkAnswer(opt)}
              >
                {opt}
              </div>
            ))}
          </div>

          <div
            className="drop-zone"
            onDragOver={(e) => e.preventDefault()}
            onDrop={handleDrop}
          >
            {dropped ? dropped : "Drag or Tap antonym here"}
          </div>
        </>
      ) : (
        <>
          <div className="options">
            {questions[currentIndex].options.map((opt, i) => (
              <button
                key={i}
                className={`option-btn ${selected === opt ? "selected" : ""}`}
                onClick={() => setSelected(opt)}
              >
                {opt}
              </button>
            ))}
          </div>
          <button className="submit-btn" onClick={handleQuizSubmit}>Submit</button>
        </>
      )}
    </div>
  );
}
